import {Component, Inject, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {faCheck} from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-advanced-date-settings',
    templateUrl: './advanced-date-settings.component.html',
    styleUrls: ['./advanced-date-settings.component.css']
})
export class AdvancedDateSettingsComponent implements OnInit {
    private injectedData: any;
    startDatePicker: Date;
    endDatePicker: Date;
    public faCheck = faCheck;
    public startTimePicker: INgbTimePicker;
    public endTimePicker: INgbTimePicker;

    constructor(private matDialogRef: MatDialogRef<AdvancedDateSettingsComponent>,
                @Inject(MAT_DIALOG_DATA) data: any) {
        this.injectedData = data;
    }

    ngOnInit() {
        this.matDialogRef.updatePosition({top: '180px', left: '0px'});
        this.startDatePicker = this.injectedData.start;
        this.endDatePicker = this.injectedData.end;
        this.startTimePicker = {
            hour: this.startDatePicker.getUTCHours(),
            minute: this.startDatePicker.getUTCMinutes(),
            second: this.startDatePicker.getUTCSeconds()
        };
        this.endTimePicker = {
            hour: this.endDatePicker.getUTCHours(),
            minute: this.endDatePicker.getUTCMinutes(),
            second: this.endDatePicker.getUTCSeconds()
        };
    }

    submit() {
        this.startDatePicker.setUTCHours(this.startTimePicker.hour);
        this.startDatePicker.setUTCMinutes(this.startTimePicker.minute);
        this.startDatePicker.setUTCSeconds(this.startTimePicker.second);

        this.endDatePicker.setUTCHours(this.endTimePicker.hour);
        this.endDatePicker.setUTCMinutes(this.endTimePicker.minute);
        this.endDatePicker.setUTCSeconds(this.endTimePicker.second);

        this.matDialogRef.close({start: this.startDatePicker, end: this.endDatePicker});
    }
}


interface INgbTimePicker {
    hour: number;
    minute: number;
    second: number;
}

